import loadable from '@loadable/component'

export default [
  {
    path: '/NewYearUnionGame',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame" */ '~/pages/NewYearUnionGame'
        )
    ),
  },
  {
    path: '/NewYearUnionGame/giftbanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame" */ '~/pages/NewYearUnionGame/giftbanner'
        )
    ),
  },
  {
    path: '/NewYearUnionGame/cardModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame" */ '~/pages/NewYearUnionGame/cardModal'
        )
    ),
  },
  {
    path: '/NewYearUnionGame/animateModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame" */ '~/pages/NewYearUnionGame/animateModal'
        )
    ),
  },
]
